Model = require('./model')
BaseCollection = require('base/collection')

class UserCallQueueCollection extends BaseCollection
  model: Model

module.exports = UserCallQueueCollection
